import SwiperSD from './component'

export default SwiperSD